// OpenDefaultOutFileHeadless.tsx
import { useEffect } from "react"
import "./index.css"
import { parseInput } from "./swmmjs_module.js"

const OpenDefaultOutFileHeadless = ({setOut, fileNames}:any) => {
  async function showFile () {
    // Read the output file
    fetch(fileNames[0])
      .then((r)=>r.arrayBuffer())
      .then(bin =>{
        setOut(bin)
      })
  }

  useEffect(()=>{
    showFile()
  }, [])

  return(
    null
  )
}
 
export {OpenDefaultOutFileHeadless}